// extracted by mini-css-extract-plugin
export default {"box":"SubAdminComponent_box__os8rH"};